import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VerifyOtpComponent } from './/verify-otp.component';

import { SignUpModule } from "./../signup/signup.module";


@NgModule({
  declarations: [VerifyOtpComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SignUpModule
  ],
  exports: [VerifyOtpComponent]
})
export class VerifyOtpModule {}